<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.854996877163648,13.49L15.844996877163648,13.5C15.934896877163649,13.65,15.994896877163649,13.81,15.994896877163649,14C15.994896877163649,14.55,15.545196877163649,15,14.99549687716365,15L1.0042648771636487,15C0.4546088771636486,15,0.004890065163648605,14.55,0.004890065163648605,14C0.004890065163648605,13.81,0.0648525771636486,13.65,0.1547958771636486,13.5L0.14480287716364862,13.49L7.140426877163649,1.49L7.150416877163648,1.5C7.330306877163649,1.2,7.6301168771636485,1,7.999886877163648,1C8.36965687716365,1,8.679466877163648,1.2,8.849356877163649,1.5L8.859356877163648,1.49L15.854996877163648,13.49ZM8.999736877163649,9.98999L7.0009868771636485,9.98999L7.0009868771636485,4.989990000000001L8.999736877163649,4.989990000000001L8.999736877163649,9.98999ZM8.999736877163649,12.99L7.0009868771636485,12.99L7.0009868771636485,10.98999L8.999736877163649,10.98999L8.999736877163649,12.99Z"
          fill-rule="evenodd"
          fill="#FFB020"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Warning',
} as DefineComponent
</script>
